<template>
  <div class="form-field">
    <label
      class="form-field-label"
      :class="{ 'form-field-label-required': required }"
      :for="`${idPrefix}-${field}`"
    >
      {{ label }}
    </label>
    <input
      :id="`${idPrefix}-${field}`"
      class="field"
      type="text"
      :autocomplete="autocomplete"
      :data-address-field="field"
      :disabled="disabled"
      :value="value ?? ''"
      :aria-invalid="Boolean(error)"
      :aria-describedby="`${idPrefix}-${field}-error`"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    />
    <p
      v-if="error"
      :id="`${idPrefix}-${field}-error`"
      class="form-field-error"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: "AddressTextField",
  props: {
    field: { type: String, required: true },
    label: { type: String, required: true },
    idPrefix: { type: String, required: true },
    value: { type: [String, Number], default: "" },
    error: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: true },
  },
  emits: ["input", "change"],
  computed: {
    autocomplete() {
      if (this.field === "street") return "address-line1";
      if (this.field === "city") return "address-level2";
      return "off";
    },
  },
};
</script>
